import { Task } from '@redux-saga/core'
import {
  ActionPattern,
  cancel,
  fork,
  race,
  spawn,
  take,
  takeLatest,
} from 'redux-saga/effects'

function takeLatestWithCancelAction(untilAction: ActionPattern) {
  return function(pattern: ActionPattern, sagaToRun: any) {
    return spawn(function*() {
      let task = null as Task

      while (true) {
        const { taskAction } = yield race({
          cancelAction: take(untilAction),
          taskAction: take(pattern),
        })

        if (task) {
          yield cancel(task)
        }
        if (taskAction) {
          task = yield fork(sagaToRun, taskAction)
        }
      }
    })
  }
}

const takeLatestWithSignOff = takeLatest
export { takeLatestWithSignOff, takeLatestWithCancelAction }
export default takeLatestWithSignOff
